<template>
    <div v-if="navigationData.length > 0" class="drawer-navigation">
        <div class="container">
            <div class="drawer-navigation__control-wrapper">
                <button :class="['burger-button',{'burger-button--open': drawerOpen}]" @click.prevent="toggleDrawer()" title="Open Navigation" type="button" >
                    <svg xmlns="http://www.w3.org/2000/svg" height="32" viewBox="0 -960 960 960" width="32">
                        <path d="M140.001-254.616v-59.999h679.998v59.999H140.001Zm0-195.385v-59.998h679.998v59.998H140.001Zm0-195.384v-59.999h679.998v59.999H140.001Z"/>
                    </svg>
                </button>
            </div>
        </div>
        <div v-if="drawerOpen" class="off-canvas off-canvas--open">
            <button
                class="off-canvas__backdrop"
                type="button"
                aria-label="Close navigation"
                @click="closeDrawer"
            ></button>
            <div :class="['off-canvas__drawer',{'off-canvas__drawer--open': drawerOpen}]">
                <div class="container">
                    <div class="mobile-nav">
                        <div class="mobile-nav__header">
                            <button :class="['burger-button',{'burger-button--open': drawerOpen}]" @click.prevent="closeDrawer()" title="Close Navigation" type="button" >
                                <svg xmlns="http://www.w3.org/2000/svg" height="32" viewBox="0 -960 960 960" width="32">
                                    <path d="M256-213.847 213.847-256l224-224-224-224L256-746.153l224 224 224-224L746.153-704l-224 224 224 224L704-213.847l-224-224-224 224Z"/>
                                </svg>
                            </button>
                        </div>
                        <div class="mobile-nav__body">
                            <transition name="mobile-nav-panel" mode="out-in">
                                <ul v-if="!activeParentItem" key="root-menu" class="mobile-nav__items">
                                    <li v-for="item of navigationData" :key="item.id" class="mobile-nav__item">
                                        <div class="mobile-nav__control">
                                            <a class="mobile-nav__link" :href="item.url" :target="item.target">
                                                {{ item.name }}
                                            </a>
                                            <button
                                                v-if="hasSubNav(item)"
                                                class="mobile-nav__toggle"
                                                :aria-label="`Open ${item.name} menu`"
                                                @click="openSubMenu(item.id)"
                                            >
                                                <span class="sr-only">Open submenu</span>
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
                                                    <path d="M504.001-480 320.616-663.384l41.692-41.693L587.384-480 362.308-254.923l-41.692-41.693L504.001-480Z"/>
                                                </svg>
                                            </button>
                                        </div>
                                    </li>
                                </ul>

                                <div v-else key="drilldown-menu" class="mobile-nav__drilldown">
                                    <button class="mobile-nav__back" type="button" @click="closeSubMenu">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
                                            <path d="M456-480 639.384-296.616l-41.692 41.693L372.616-480l225.076-225.077 41.692 41.693L456-480Z"/>
                                        </svg>
                                        Back
                                    </button>

                                    <h2 class="mobile-nav__drilldown-title">{{ activeParentItem.name }}</h2>

                                    <div class="mobile-nav__drilldown-groups">
                                        <ul v-for="(subNav, index) in activeParentItem.subNavigation" :key="index" class="mobile-nav__sub-items">
                                            <li v-if="subNav.title" class="mobile-nav__sub-label">
                                                <a v-if="subNav.feature" :href="subNav.feature.url" :target="subNav.feature.target">
                                                    {{ subNav.title }}
                                                </a>
                                                <template v-else>
                                                    {{ subNav.title }}
                                                </template>
                                            </li>
                                            <li v-for="subItem of subNav.items" class="mobile-nav__sub-item" :key="subItem.id">
                                                <a class="mobile-nav__sub-link" :href="subItem.url" :target="subItem.target">
                                                    {{ subItem.name }}
                                                </a>
                                            </li>
                                            <li v-if="subNav.feature" class="mobile-nav__sub-item mobile-nav__sub-item--feature">
                                                <a class="mobile-nav__sub-link" :href="subNav.feature.url" :target="subNav.feature.target">
                                                    <span>{{ subNav.feature.name }}</span>
                                                    <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 -960 960 960" width="20">
                                                        <path d="M262.771-210.001 460.719-480 262.771-749.999h61.742L522.461-480 324.513-210.001h-61.742Zm241.692 0L702.411-480 504.463-749.999h61.742L764.153-480 566.205-210.001h-61.742Z"/>
                                                    </svg>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </transition>
                        </div>

                        <div v-if="$slots.mobilecontrols" class="mobile-nav__utility">
                            <slot name="mobilecontrols"></slot>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'drawer-navigation',
    data() {
        return {
            drawerOpen: false,
            activeSubMenuId: null
        };
    },
    props: {
        navigationData: {
            type: Array,
            required: true,
            default: () => []
        }
    },
    computed: {
        activeParentItem() {
            return this.navigationData.find((item) => item.id === this.activeSubMenuId) || null;
        }
    },
    watch: {
        drawerOpen(isOpen) {
            if (typeof document !== 'undefined' && document.body) {
                document.body.classList.toggle('mobile-drawer-open', isOpen);
            }
        }
    },
    methods: {
        hasSubNav(item) {
            return item.subNavigation && item.subNavigation.length > 0;
        },
        toggleDrawer() {
            this.drawerOpen = !this.drawerOpen;

            if (!this.drawerOpen) {
                this.activeSubMenuId = null;
            }
        },
        closeDrawer() {
            this.drawerOpen = false;
            this.activeSubMenuId = null;
        },
        openSubMenu(id) {
            this.activeSubMenuId = id;
        },
        closeSubMenu() {
            this.activeSubMenuId = null;
        }
    },
    beforeUnmount() {
        if (typeof document !== 'undefined' && document.body) {
            document.body.classList.remove('mobile-drawer-open');
        }
    }
}
</script>
